module.exports = __webpack_public_path__ + "static/img/bruce-mars-8YG31Xn4dSw-unsplash_thumb.db44a10.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/bruce-mars-8YG31Xn4dSw-unsplash_thumb.png
// module id = x7r7
// module chunks = 4